import { defineComponent as r, createElementBlock as t, openBlock as a, normalizeClass as o } from "vue";
const c = /* @__PURE__ */ r({
  name: "RevDivider",
  __name: "Divider",
  props: {
    variant: { default: "horizontal" }
  },
  setup(e) {
    return (n, l) => (a(), t("hr", {
      class: o(["border-static-default-low", {
        "border-l-1 border-t-0": e.variant === "vertical",
        "border-t": e.variant === "horizontal"
      }])
    }, null, 2));
  }
});
export {
  c as default
};
